import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home-faq section pb-0" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "heading text-center" }
const _hoisted_4 = { class: "mt-15 text-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "heading" }
const _hoisted_7 = {
  class: "answer xyz-in",
  xyz: "fade duration-8"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "show-more text-center text-dark" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "heading" }
const _hoisted_12 = {
  class: "xyz-in answer",
  xyz: "fade duration-8"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "heading" }
const _hoisted_16 = {
  class: "xyz-in answer",
  xyz: "fade duration-8"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "show-more text-center text-dark with-bg" }

import { strings } from '@/strings'
import Icon from '@/components/icons/icon.vue'
import { ref } from 'vue'

// faq tab active item index

export default /*#__PURE__*/_defineComponent({
  __name: 'home-faq',
  setup(__props) {

const active = ref(0)
//  faq item on select
const on_select = (i: number) => {
  active.value = i
}

const show_more = ref(false)
const on_show_more= () => {
  show_more.value = !show_more.value
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(strings).faqs['section-title']), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(strings).faqs['section-sub-heading']), 1)
      ]),
      (show_more.value)
        ? (_openBlock(), _createElementBlock("div", {
            class: "faq-list mt-4",
            key: show_more.value
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(21, (n, i) => {
              return _createElementVNode("article", {
                key: i,
                onClick: ($event: any) => (on_select(i)),
                class: _normalizeClass(["item card bg-white", {'active': active.value === i}])
              }, [
                _createElementVNode("h2", _hoisted_6, [
                  _createVNode(Icon, {
                    class: "text-secondary",
                    icon: "question"
                  }),
                  _createElementVNode("span", null, _toDisplayString(_unref(strings).faqs[`q${n}`]), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", {
                    innerHTML: _unref(strings).faqs[`a${n}`]
                  }, null, 8, _hoisted_8)
                ])
              ], 10, _hoisted_5)
            }), 64)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", { onClick: on_show_more }, _toDisplayString(_unref(strings).faqs['show-less']), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            class: "faq-list mt-4",
            key: show_more.value
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (n, i) => {
              return _createElementVNode("article", {
                key: i,
                onClick: ($event: any) => (on_select(i)),
                class: _normalizeClass(["item card bg-white", {'active': active.value === i}])
              }, [
                _createElementVNode("h2", _hoisted_11, [
                  _createVNode(Icon, {
                    class: "text-secondary",
                    icon: "question"
                  }),
                  _createElementVNode("span", null, _toDisplayString(_unref(strings).faqs[`q${n}`]), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", {
                    innerHTML: _unref(strings).faqs[`a${n}`]
                  }, null, 8, _hoisted_13)
                ])
              ], 10, _hoisted_10)
            }), 64)),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([8,9,10,11,12,13,14,15,16,17,18,19,20,21], (n, i) => {
              return _createElementVNode("article", {
                key: i,
                onClick: ($event: any) => (on_select(i)),
                class: _normalizeClass(["item card bg-white hidden", {'active': active.value === i}]),
                "aria-disabled": "true",
                "aria-hidden": "true"
              }, [
                _createElementVNode("h2", _hoisted_15, [
                  _createVNode(Icon, {
                    class: "text-secondary",
                    icon: "question"
                  }),
                  _createElementVNode("span", null, _toDisplayString(_unref(strings).faqs[`q${n}`]), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", {
                    innerHTML: _unref(strings).faqs[`a${n}`]
                  }, null, 8, _hoisted_17)
                ])
              ], 10, _hoisted_14)
            }), 64)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", { onClick: on_show_more }, _toDisplayString(_unref(strings).faqs['show-more']), 1)
            ])
          ]))
    ])
  ]))
}
}

})